import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { Tabs, Tab } from "@mui/material";
import ClientFeedbackTable from "components/clientfeedback/ClientFeedbackTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import ClientFeedbackServices from "services/ClientFeedbackServices";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { SidebarContext } from "context/SidebarContext";
import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
import { FiRefreshCcw } from "react-icons/fi";
import { useLocation } from "react-router-dom";

const ClientFeedback = () => {
  const location = useLocation();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const [loading, setLoading] = useState(false);
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const [itemsPerPage, setItemsPerPage] = useState(0);
  const [tab, setTab] = useState(0);
  const [error, setError] = useState(false);
  const [clientfeedbackData, setClientFeedbackData] = useState([]);
  // const [paymentStatus, setPaymentStatus] = useState("unpaid");
  const [status, setStatus] = useState(false);
  const {
    clientfeedbackRef,
    dataTable,
    serviceData,
    handleSubmitClientFeedback,
    //   currentPage,
  } = useFilter(clientfeedbackData, itemsPerPage);

  useEffect(() => {
    if (clientfeedbackData.length !== 0) {
      setItemsPerPage(clientfeedbackData.length);
    }
  }, [serviceData]);

  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const parseDate = (str) => {
    if (!str) return null;
    const [dd, mm, yyyy] = str.split("-");
    const date = new Date(yyyy, mm - 1, dd);
    return isNaN(date.getTime()) ? null : date;
  };

//   const filterByStartDate = (data, searchStart, searchEnd) => {
//   if (!searchStart || !searchEnd) return data;

//   return data.filter(item => {
//     const tripStart = parseDate(item.start_date); // DD-MM-YYYY
//     if (!tripStart) return false;

//     return (
//       tripStart >= searchStart &&
//       tripStart <= searchEnd
//     );
//   });
// };


  // const formattedDates = {
  //   start_date: searchstartDate ? formatDate(searchstartDate) : "",
  //   end_date: searchendDate ? formatDate(searchendDate) : "",
  // };


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlType = params.get("type");
    if (urlType) {
      const parsed = Number(urlType);
      if (!isNaN(parsed) && parsed >= 1 && parsed <= 4) {
        setTab(parsed - 1);
      }
    }
    const start = params.get("start");
    const end = params.get("end");

    const startDate = parseDate(start);
    const endDate = parseDate(end);

    if (startDate) {
      setSearchStartDate((prev) =>
        prev?.getTime() === startDate.getTime() ? prev : startDate
      );
    }

    if (endDate) {
      setSearchEndDate((prev) =>
        prev?.getTime() === endDate.getTime() ? prev : endDate
      );
    }
  }, [location.search]);

  useEffect(() => {

    const fetchClientFeedback = async () => {
      setLoading(true);

      try {
        let response;
        if (tab === 0) {
          let payload = {
            type: 1,

            start_date: searchstartDate ? formatDate(searchstartDate) : "",
            end_date: searchendDate ? formatDate(searchendDate) : "",
          };

          response = await ClientFeedbackServices.clientfeedbackRequestList(
            payload
          );
        
        } else if (tab === 1) {
          let payload = {
            type: 2,
            start_date: searchstartDate ? formatDate(searchstartDate) : "",
            end_date: searchendDate ? formatDate(searchendDate) : "",
          };

          response = await ClientFeedbackServices.clientfeedbackRequestList(
            payload
          );
    		
        }
        const updatedData =
          response?.data?.map(
            ({
              client_id,
              ref_no,
              is_online,
              company_name,
              arrival,
              departure,
              arrival_details,
              arrival_time,
              package_type,
              start_date,
              end_date,
              driver_name,
              driver_contact_no,
              vehicle_reg_no,
              vehicle_name,
              contact_no,
              vehicle_modal,
              arrival_via,
              departure_via,
              departure_details,
              ontour_feedback,
              vehicle_remark,
              agent_ref_no,
              days_to_complete,
              ...rest
            }) => ({
              client_id,
              ref_no,
              is_online,
              company_name,
              arrival,
              departure,
              arrival_details,
              arrival_time,
              package_type,
              start_date,
              end_date,
              driver_name,
              driver_contact_no,
              vehicle_reg_no,
              vehicle_name,
              contact_no,
              vehicle_modal,
              arrival_via,
              departure_via,
              departure_details,
              ontour_feedback:
                typeof ontour_feedback === "string"
                  ? ontour_feedback
                  : JSON.stringify(ontour_feedback || ""),
              vehicle_remark,
              agent_ref_no,
              days_to_complete,
              ...rest,
            })
          ) || [];

        // const frontendFilteredData = filterByStartDate(
        //   updatedData,
        //   searchstartDate,
        //   searchendDate
        // );

        setClientFeedbackData(updatedData);
        setStatus(response?.status);
    

      } catch (error) {
        console.error('Error fetching clientfeedback:', error);
        setStatus(false);
        setError(true);
        //notifyError("Failed to fetch clientfeedback. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    if (!isUpdate && location.search && !searchstartDate && !searchendDate) {
      // console.log("Skipping initial fetch — waiting for URL date parsing");
      return;
    }
    fetchClientFeedback();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate, searchstartDate, searchendDate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };
  const currentPage = 1;
  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "tour feedback" && perm.view === 1
    );

  const handleRefresh = () => {
    setIsUpdate(true);
    setSearchStartDate(null);
    setSearchEndDate(null);
  };
  // console.log(dataTable)
  return (
    <>
      {hideView && (
        <>
          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="Start Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="End Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchendDate}
                        min={searchstartDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={clientfeedbackRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    autoComplete="off"
                    name="search"
                    placeholder="Quick Search"
                    onChange={handleSubmitClientFeedback}
                  />
                </div>

                <Button
                  className="rounded-md h-10 px-8"
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  Search
                </Button>

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            {/* <Tab label="All" /> */}
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Not Submitted"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Submitted"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer
                style={{
                  maxHeight: "65vh",
                  overflow: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header text-center capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell>Sl.No.</TableCell>
                      <TableCell>Ref No.</TableCell>
                      <TableCell>Trip Date</TableCell>
                      <TableCell>Arrival / Departure</TableCell>
                      <TableCell>Client Name</TableCell>
                      {tab === 1 && <TableCell>Feedback</TableCell>}
                      <TableCell>Days to complete</TableCell>
                      <TableCell>Service Type</TableCell>
                      <TableCell>Vehicle Remark</TableCell>
                    </tr>
                  </TableHeader>
                  <ClientFeedbackTable
                    clientfeedback={dataTable}
                    perpage={itemsPerPage}
                    currentPage={currentPage}
                    tab={tab}
                  />
                </Table>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Client FeedBacks." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default ClientFeedback;
